import { buildDefaultLiveMobileProps } from "../buildDefaultLiveMobileProps";
import { getBackgroundImage } from "../../helpers";
export const buildDefaultLiveDesktopProps = (event, config) => {
    return Object.assign(Object.assign({}, buildDefaultLiveMobileProps(event, config)), { backgroundImage: getBackgroundImage(event, config.cmsConfig.backgroundImages) });
};
//# sourceMappingURL=buildDefaultLiveDesktopProps.js.map